import { render, staticRenderFns } from "./ShowRequest.vue?vue&type=template&id=5a3fa578&"
import script from "./ShowRequest.vue?vue&type=script&lang=js&"
export * from "./ShowRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports